import PhysicianResult from 'generated/Result/Physician/Models/PhysicianResult';
import { GET_PATIENT_PHYSICIAN } from '../types/physician';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface PhysicianState {
  patientPhysician: PhysicianResult
}

const INITIAL_STATE: PhysicianState = {
  patientPhysician: null,
};

const physicianReducer = function (state: PhysicianState = INITIAL_STATE, action: PayloadAction<any>): PhysicianState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_PATIENT_PHYSICIAN:
      return { ...state, patientPhysician: action.payload };

    default:
      return state;
  }
};

export default physicianReducer;
